export default __webpack_public_path__ + "static/media/Note-icon.b0b7b5fe.svg";